// SAVING THE LETTER PDF THE SERVER RENDERED (R207).
//
// `v2GenerateLetter` op `pdf` answers the file's bytes as base64, the way photographs travel to `op:"evidence"`; this
// hands them to the browser as a download under the server's own file name. Nothing about the file is decided here.

/** Decode, wrap as a PDF and let the browser save it under `filename`. Returns false where the browser cannot make an
 *  object URL (a test environment without one), so the caller never pretends a download happened. */
export function savePdf(base64: string, filename: string, doc: Document = document): boolean {
  if (typeof URL.createObjectURL !== "function") return false;
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
  const link = doc.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  doc.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return true;
}
